import React from "react";
import ProductListProvider from "../ProductListProvider/ProductListProvider";
import ListLoader from "../../utils/loader/ListLoader";
import ProductListFilter from "../FiltersList/ProductListFilter";
import ListViewMoreButton from "./ListViewMoreButton";
import ListItems from "./ListItems";

export type ProductListProps = {
  shopId: number;
  categoryId: number;
  customerId: number;
  visitorId: string;
  customerGroupId: number;
  currency?: string;
};

/**
 * The whole list view component, consisting of
 * - filter buttons
 * - product list
 * - buttons for further actions
 *
 * all nested in corresponding context provider. The `showFilters` state is placed here
 * @param props Default params of type `ProductListProps`
 * @constructor
 */
const ProductList: React.FC<ProductListProps> = (props) => (
  <React.Suspense fallback={<ListLoader />}>
    <ProductListProvider {...props}>
      <ProductListFilter />
      <ListItems />
      <ListViewMoreButton />
    </ProductListProvider>
  </React.Suspense>
);

export default ProductList;
